export default __webpack_public_path__ + "static/media/02.53e0a5e4.png";